import React, { useState } from 'react';
import Modal from '../common/Modal';
import Button from '../common/Button';
import { businessPermitsAPI } from '../../services/api/admin/businessPermitApi';

const UpdatePermitStatusModal = ({ isOpen, onClose, application, onSubmit }) => {
  const [selectedStatus, setSelectedStatus] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const statusOptions = [
    { value: 'draft', label: 'Draft' },
    { value: 'submitted', label: 'Submitted' },
    { value: 'under_review', label: 'Under Review' },
    { value: 'endorsed', label: 'Endorsed' },
    { value: 'approved', label: 'Approved' },
    { value: 'rejected', label: 'Rejected' }
  ];

  const handleSubmit = async () => {
    if (!selectedStatus || !application?.id) return;

    setIsLoading(true);
    try {
      // Call the updatePermitStatus API
      const response = await businessPermitsAPI.updatePermitStatus(application.id, {
        status: selectedStatus
      });

      // Call the onSubmit callback with the updated application data
      if (onSubmit) {
        onSubmit({
          ...application,
          status: selectedStatus,
          ...response.data // Include any response data
        });
      }

      onClose();
      setSelectedStatus('');
    } catch (error) {
      console.error('Error updating permit status:', error);
      // You might want to add error handling here (e.g., toast notification)
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    onClose();
    setSelectedStatus('');
  };

  return (
    <Modal isOpen={isOpen} onClose={handleCancel} title="Update Business Permit Status" size="md">
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Select status
          </label>
          <select
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">Choose a status...</option>
            {statusOptions.map((status) => (
              <option key={status.value} value={status.value}>
                {status.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="flex justify-end gap-3 mt-6">
        <Button variant="outline" onClick={handleCancel}>
          Cancel
        </Button>
        <Button 
          variant="primary" 
          onClick={handleSubmit}
          disabled={!selectedStatus || isLoading}
        >
          {isLoading ? 'Updating...' : 'Confirm'}
        </Button>
      </div>
    </Modal>
  );
};

export default UpdatePermitStatusModal;
